export default __webpack_public_path__ + "static/media/TF.28cc4fb6.webp";